import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.scss";
const CustomInput = forwardRef(({ value, onClick, calenderImage ,showIcon = true}, ref) => (
  <div className="date-time-container" onClick={onClick} ref={ref}>
    <span>Select Date</span>
    {showIcon && (
      <span>
        <img src={calenderImage} alt="calendar" />
      </span>
    )}
    <span>
      <b>{value || "Select Date"}</b>
    </span>
  </div>
));

export default function CustomDatePicker({ value, onChange, calenderImage,showIcon = true, }) {
  return (
    <div className="border">
        <DatePicker
      selected={value}
        onChange={(date) => {
    onChange(date);
  }}
      minDate={new Date()}
      dateFormat="dd MMM yyyy"
      customInput={<CustomInput calenderImage={calenderImage}  showIcon={showIcon} />}
      calendarClassName="dp-calendar"
      popperClassName="dp-popper"
    />
    </div>
  );
}
